import React from "react";
import ReactDOM from "react-dom";
import styles from "src/styles/components/elements/modal.module.scss";

const Modal = ({ children, customSizeClass, closeModal }) => {
  const domEl = document.getElementById("modal-root");
  if (!domEl) return null;

  return ReactDOM.createPortal(
    <>
      <div
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        onClick={closeModal}
        className={styles.modal}
      >
        <div
          className={`${styles.modal_dialog} ${customSizeClass}`}
          role="document"
        >
          <div
            className="modal_content"
            onClick={(event) => event.stopPropagation()}
          >
            {children}
          </div>
        </div>
      </div>
      <div className={styles.modal_backdrop} onClick={closeModal}></div>
    </>,
    domEl
  );
};

export default Modal;
